import { Link } from "react-router";
import TournamentMeta from "./TournamentMeta";
import type { TournamentProps } from "~/helpers/prepare-tournament-data";
import { getTournamentStatus } from "~/helpers/prepare-tournament-data";
import { parseDateRange } from "~/utils/belt";

const TournamentCard: React.FC<{
  tournament: TournamentProps;
  isWide?: boolean;
  showMeta?: boolean;
}> = ({ tournament, isWide, showMeta }) => {
  const { tournamentStatus } = getTournamentStatus({
    registeredParticipants: tournament.registeredParticipants,
    matchesPlayed: tournament.matchesPlayed,
    ...tournament.dates,
  });

  return (
    <div className="relative">
      <Link
        to={`/tournaments/${tournament.id}`}
        className={`grid grid-rows-[95%_5%] relative box-border px-6 py-4 pb-0 ${
          isWide
            ? "w-[22.375rem] h-[26.125rem] m-auto"
            : "w-[17.5rem] h-[29rem]"
        }`}
        style={{
          alignItems: "end",
        }}
        prefetch="intent"
      >
        {/* Image */}
        <div className="flex absolute w-full h-full items-center justify-center rounded-md overflow-hidden z-0">
          <div className="absolute overlay translate-[translate3d(0,0,0)] w-full h-full top-0 bg-gradient-to-t from-black z-10" />
          <img
            src={tournament.posterURL}
            alt={`${tournament.name} poster`}
            className="z-0 bg-cover bg-left-top w-auto h-full max-w-none"
            style={{ transform: "translateZ(0) scale(1.05)" }}
          />
        </div>
        {/* Content */}
        <div className="flex flex-col uppercase font-bold text-[#fff] z-10">
          <span
            className="text-[0.65rem] box-border px-1 py-[0.125rem] pb-0 bg-grey-dark w-fit mb-2"
            style={{
              backgroundColor:
                tournamentStatus === "registering"
                  ? "#5EC65D"
                  : tournamentStatus === "ongoing"
                  ? "#701129"
                  : tournamentStatus === "upcoming"
                  ? "teal"
                  : undefined,
            }}
          >
            {tournamentStatus}
          </span>
          <h3 className="text-sm mb-[0.125rem]">{tournament.name}</h3>
          <h4 className="text-xs text-grey-light">
            {parseDateRange(
              tournament.dates.tournamentDates.start,
              tournament.dates.tournamentDates.end
            )}
          </h4>
        </div>
      </Link>
      {showMeta && (
        <TournamentMeta
          platform={tournament.platform}
          tournamentType={tournament.tournamentType} //" Group stage + Knockout"
          intendedParticipants={tournament.intendedParticipants!}
          teamType={tournament.teamType}
        />
      )}
    </div>
  );
};

export default TournamentCard;
